import {SharedDevicesModel} from '@store/shared-devices/shared-devices.model';
import {Action, State, StateContext} from '@ngxs/store';
import {IResponse} from '@interfaces/response';
import {ISharedDevice} from '@interfaces/shared-devices';
import {Injectable} from '@angular/core';
import {
  DisableSharedDeviceLoader,
  EnableSharedDeviceLoader,
  FetchSharedDevices,
  SearchSharedDevices,
  SetSharedDevicesPage,
  SortSharedDevices
} from '@store/shared-devices/shared-devices.actions';
import {Observable} from 'rxjs';
import {SharedDevicesService} from '@services/shared-devices/shared-devices.service';
import {tap} from 'rxjs/operators';

@State<SharedDevicesModel>({
  name: 'sharedDevicesState',
  defaults: {
    currentPage: 1,
    searchParam: '',
    sharedDevices: null,
    sort: 'updatedAt',
    order: 'DESC',
    itemsPerPage: 20,
    loader: false
  }
})
@Injectable()
export class SharedDevicesState {
  constructor(private sharedDevicesService: SharedDevicesService) {
  }

  @Action(FetchSharedDevices, {cancelUncompleted: true})
  fetchSharedDevices(ctx: StateContext<SharedDevicesModel>): Observable<any> {
    const limit = ctx.getState().itemsPerPage;
    const skip = limit * (ctx.getState().currentPage - 1);
    const search = ctx.getState().searchParam;
    const order = ctx.getState().order;
    const sort = ctx.getState().sort;

    ctx.dispatch(new EnableSharedDeviceLoader());
    return this.sharedDevicesService
        .getSharedDevices({search, skip, sort, limit, order})
      .pipe(
        tap((sharedDevices: IResponse<ISharedDevice>) => {
          const state = ctx.getState();
          ctx.setState({...state, sharedDevices});
          ctx.dispatch(new DisableSharedDeviceLoader());
        })
      );
  }

  @Action(SetSharedDevicesPage)
  setSharedDevicesPage(ctx: StateContext<SharedDevicesModel>, {page}: SetSharedDevicesPage): Observable<any> {
    ctx.patchState({currentPage: page});
    return ctx.dispatch(new FetchSharedDevices());
  }

  @Action(SearchSharedDevices)
  searchSharedDevices(ctx: StateContext<SharedDevicesModel>, {search}: SearchSharedDevices): Observable<any> {
    ctx.patchState({searchParam: search, currentPage: 1});
    return ctx.dispatch(new FetchSharedDevices());
  }

  @Action(SortSharedDevices)
  sortSharedDevices(ctx: StateContext<SharedDevicesModel>, {payload}: SortSharedDevices): Observable<any> {
    ctx.patchState({sort: payload.sort, order: payload.order});
    return ctx.dispatch(new FetchSharedDevices());
  }

  @Action(EnableSharedDeviceLoader)
  enableSharedDeviceLoader(ctx: StateContext<SharedDevicesModel>): void {
    ctx.patchState({loader: true});
  }

  @Action(DisableSharedDeviceLoader)
  disableSharedDeviceLoader(ctx: StateContext<SharedDevicesModel>): void {
    ctx.patchState({loader: false});
  }
}
